export const LIST_DOCUMENT = [
  {
    id: 1,
    value: 'ruc',
    label: 'RUC',
    name: 'RUC',
    active: false,
  },
  {
    id: 2,
    value: 'dni',
    label: 'DNI',
    name: 'DNI',
    active: true,
  },
  {
    id: 4,
    value: 'ce',
    label: 'C.E.',
    name: 'CE',
    active: true,
  },
];

export const getDocumentType = (id) => LIST_DOCUMENT.find((_) => _.id === id);
export const getDocumentTypeByValue = (value) => LIST_DOCUMENT.find((_) => _.value === value);
